<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_forms_route_page_title')">
    <server-table
      class="text-center groovemail-admin-forms-table"
      ref="serverTable"
      :url="adminFormsListingUrl"
      tableRef="formsTable"
      :slotData="adminFormTableSlotData"
      :tableColumns="adminFormsTableColumns"
      :tableOptions="adminFormsTableOptions"
      tableTitle="frontend_groovemail_components_pricepoint_sidebar_forms"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="subscribermodel"
      name="view-subscribers-modal"
      :title="this.$t('frontend_groovemail_admin_forms_subscribers_detail')"
    >
      <div class="gm-admin-modal__body">
        <client-table
          class="groovemail-forms-subscribers-table"
          :tableRef="'subscriberTable'"
          :tableData="subscribers"
          :tableColumns="subscriberColumns"
          :tableOptions="subscriberOptions"
          :tableCondition="subscribers.length"
          :slotData="subscriberTableSlotData"
        >
        </client-table>
      </div>
    </gs-named-modal>
    <user-access-model ref="userAccess" @refreshTable="refreshTable"></user-access-model>
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ClientTable from '@groovepages/gd-ui-kit/components/tables/ClientTable.vue';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import { adminUrls } from '@/utils/urls.js';
import { getData } from '@/utils/apiHelper.js';
import userStatusSvgImages from './UserStatusSvg.js';
import UserAccessModel from '@/components/UserAccessModel.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_components_pricepoint_sidebar_forms'),
    };
  },
  mixins: [demoModeValuesMixin],
  data() {
    return {
      appName: '',
      adminFormsListingUrl: adminUrls.adminFormsUrl.formsListing,
      subscribers: [],
      userStatusSvgImages: userStatusSvgImages,
      adminFormsTableColumns: [
        'name',
        'user.name',
        'status',
        'user.email',
        'total_leads',
        'last24hour',
        'submission',
        'form_unique_sum',
        'form_impression_sum',
        'firstsubscriber',
      ],
      adminFormsTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [
          'name',
          'total_leads',
          'submission',
          'form_unique_sum',
          'form_impression_sum',
          'last24hour',
        ],
        filterable: ['name'],
        headings: {
          name: () => this.$t('frontend_builder_form'),
          'user.name': () =>
            this.$t('frontend_groovemail_admin_forms_owner_name'),
          'user.email': () =>
            this.$t('frontend_groovemail_admin_forms_owner_email'),
          status: () =>
            this.$t('frontend_groovemail_admin_forms_owner_status'),
          submission: () =>
            this.$t('frontend_groovemail_admin_forms_submissions_percent'),
          form_unique_sum: () =>
            this.$t('frontend_groovemail_admin_forms_unique_percent'),
          form_impression_sum: () =>
            this.$t('frontend_groovemail_admin_forms_impressions_percent'),
          total_leads: () =>
            this.$t('frontend_groovemail_admin_forms_total_subscribed_users'),
          last24hour: () =>
            this.$t('frontend_groovemail_admin_forms_last_24_users'),
          firstsubscriber: () =>
            this.$t('frontend_groovemail_admin_forms_subscribers_detail'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              user: {
                id: obj?.user?.id,
                name: self.basicText,
                email: self.basicEmailText,
              } }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data.data,
            count: data.total,
          };
        },
      },
      subscriberColumns: [
        'lead.contact.first_name',
        'lead.contact.last_name',
        'lead.email',
        'lead.contact.phone_number',
        'lead.contact.ip_address',
      ],
      subscriberOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: ['first_name', 'last_name', 'email'],
        filterable: [
          'first_name',
          'last_name',
          'email',
          'phone_number',
          'ip_address',
        ],
        headings: {
          'lead.contact.first_name': () => this.$t('frontend_groovemail_email_show_firstname'),
          'lead.contact.last_name': () => this.$t('frontend_groovemail_email_show_lastname'),
          'lead.email': () => this.$t('frontend_groovemail_email_show_email'),
          'lead.contact.phone_number': () =>
            this.$t('frontend_sites_account_modal_phone_number'),
          'lead.contact.ip_address': () =>
            this.$t('frontend_groovemail_contacts_step2_ip_address'),
        },
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
      },
    };
  },

  components: {
    AdminPageShell,
    ClientTable,
    ServerTable,
    UserAccessModel,
  },

  created() {
    self = this;
  },

  mounted() {
    this.appName = this.supBrandName;
  },

  watch: {
    // Used to refresh admin forms table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.formsTable.refresh();
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    /**
     * Opens a modal to display details of Form Recipients.
     * @param {string} id contains unique id of a form.
     */
    async openFormRecipients(id) {
      this.$root.$emit('modal-open', 'view-subscribers-modal');
      this.subscribers = [];
      const { data } = await getData(`${adminUrls.adminFormsUrl.formsSubscribers}/${id}`);
      if (data.length) {
        self.subscribers = data;
      }
    },
  
    refreshTable() {
      this.$refs.serverTable.$refs.formsTable.refresh();
    },    
  },

  computed: {
    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.supBrand.title;
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
    
    subscriberTableSlotData() {
      return [
        {
          slotName: 'first_name',
          slotType: 'default',
          showDescription: false,
          defaultVal: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'last_name',
          slotType: 'default',
          showDescription: false,
          defaultVal: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'email',
          slotType: 'default',
          showDescription: false,
          defaultVal: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'phone_number',
          slotType: 'default',
          showDescription: false,
          defaultVal: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'ip_address',
          slotType: 'default',
          showDescription: false,
          defaultVal: this.$t('frontend_groovemail_not_available'),
        },
      ];
    },

    adminFormTableSlotData() {
      return [
        {
          slotName: 'name',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.name
              ? props.row.name
              : this.$t('frontend_affiliate_index_NA');
          },
        },
        {
          slotName: 'status',
          slotType: 'tooltip',
          showText: false,
          textValue: (props) => {
            return '';
          },
          classes: () => {
            return '';
          },
          conditions: () => {
            return true;
          },
          content: (props) => {
            if((props.row.user.status==1 || props.row.user.groovemail_smtp == 0) && (props.row.user.block_reason !='' || props.row.user.blocked_by !='')){
              let tooltipContent = `<div class='flex'>`;            
              tooltipContent += `<p class='pl-1 break-words'>${props.row.user.block_reason}</p></div>`;
              tooltipContent += `<div class='flex'><p class='font-semibold break-words'>${this.$t(
              'frontend_groovemail_admin_forms_blocked_by'
            )}:</p><p class='pl-1 break-words'>${props.row.user.blocked_by}</p></div>`;
            return tooltipContent;
            }
          },
          html: (props) =>{
            if(props.row.user.status==1){
              return `<p class='user-status-cross-icons'>${this.userStatusSvgImages[0].crossicon}<span>Disabled ${this.appName}</span></p>`;
            }else if(props.row.user.groovemail_smtp == 0){
              return `<p class='user-status-ban-icons'>${this.userStatusSvgImages[0].banicon}<span>Disabled Smtp</span></p>`;   
            }else{
              return `<p class='user-status-check-icons'>${this.userStatusSvgImages[0].checkicon}<span>All Good</span></p>`;
            }
          }
        },
        {
          slotName: 'total_leads',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.total_leads ? props.row.total_leads : 0;
          },
        },
        {
          slotName: 'last24hour',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.last24hour ? props.row.last24hour : 0;
          },
        },
        {
          slotName: 'firstsubscriber',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_groovemail_view'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openFormRecipients(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_groovemail_disable_smtp'),
              conditions: (props) => {
                if(props.user.groovemail_smtp == 0 || props.user.status == 1){
                  return false;
                }
                return true;
              },
              callback: (props) => this.$refs.userAccess.editUserAccess(props.row.user_id,'smtp'),
            },
            {
              id: 2,
              name: () => this.$t('frontend_groovemail_disable_access'),
              conditions: (props) => {
                if(props.user.status == 1){
                  return false;
                }
                return true;
              },
              callback: (props) => this.$refs.userAccess.editUserAccess(props.row.user_id,'access'),
            },
            {
              id: 3,
              name: () => this.$t('frontend_groovemail_admin_enable_access'),
              conditions: (props) => {
                if(props.user.status == 1){
                  return true;
                }
                return false;
              },
              callback: (props) => this.$refs.userAccess.enableUserAccess(props.row.user_id,'access'),
            },
            {
              id: 4,
              name: () => this.$t('frontend_groovemail_admin_enable_smtp'),
              conditions: (props) => {
                if(props.user.status == 0 && props.user.groovemail_smtp == 0){
                  return true;
                }
                return false;
              },
              callback: (props) => this.$refs.userAccess.enableUserAccess(props.row.user_id,'smtp'),
            }
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-forms-subscribers-table #gd-client-table-view {
  .VueTables__table th:last-child span {
    display: block;
  }
}

.groovemail-admin-forms-table #gd-server-table-view {
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(1) {
      width: 12%;
    }
    td:nth-child(2),
    th:nth-child(2) {
      width: 12%;
    }
    td:nth-child(3),
    th:nth-child(3) {
      width: 16%;
    }
    td:nth-child(4),
    th:nth-child(4) {
      width: 15%;
    }
  }
}

/* User status chips rendered from script-owned slot markup. No warning token exists yet
   (DESIGN.md §2.1), so the "ban" state keeps its amber literal as a known exception. */
.user-status-ban-icons,
.user-status-cross-icons,
.user-status-check-icons {
  display: inline-flex;
  align-items: center;
}

.user-status-ban-icons svg,
.user-status-cross-icons svg,
.user-status-check-icons svg {
  border-radius: var(--gs-radius-sm);
  padding: 3px;
  margin-right: 4px;
}

.user-status-ban-icons span {
  color: orange;
}

.user-status-ban-icons svg {
  background: orange;
}

.user-status-cross-icons span {
  color: var(--gs-danger);
}

.user-status-cross-icons svg {
  background: var(--gs-danger);
}

.user-status-check-icons span {
  color: var(--gs-success);
}

.user-status-check-icons svg {
  background: var(--gs-success);
}

.swal2-title {
  font-size: 20px;
  font-weight: 600;
}
</style>
